/* ============================================================
   FARREN — MOBILE BEHAVIORS (V99)
   1) Body scroll lock when drawer/modal/mobileMenu açıkken
   2) Klavye tespiti (iOS Safari + Android) → body.keyboard-open
   3) Footer akordeon (.foot__col h5 click → toggle .is-open)
   4) Mobile menu akordeon (.mm-head dataset-open → .mm-body data-for)
   5) ?debug=overflow ile taşan elementleri kırmızı outline ile göster
   ============================================================ */

(function(){
  'use strict';

  /* ─────────────────────────────────────────────
     1. BODY SCROLL LOCK — Drawer/modal açıldığında
     ───────────────────────────────────────────── */
  let scrollY = 0;

  function lockBody(){
    scrollY = window.scrollY;
    document.body.classList.add('no-scroll');
    document.body.style.top = '-' + scrollY + 'px';
  }

  function unlockBody(){
    document.body.classList.remove('no-scroll');
    document.body.style.top = '';
    window.scrollTo(0, scrollY);
  }

  // Drawer/modal state izleyici
  const stateObserver = new MutationObserver(() => {
    const anyOpen = document.querySelector(
      '.cartDrawer.is-open, .cart-drawer.is-open, ' +
      '.mobileMenu.is-open, .mobile-menu.is-open, ' +
      '.modal.is-open, .modal.is-active'
    );
    const isLocked = document.body.classList.contains('no-scroll');
    if (anyOpen && !isLocked) lockBody();
    else if (!anyOpen && isLocked) unlockBody();
  });

  stateObserver.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class']
  });


  /* ─────────────────────────────────────────────
     2. KLAVYE TESPİTİ (iOS Safari, Android)
     ───────────────────────────────────────────── */
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', () => {
      const isKeyboardOpen = window.visualViewport.height < window.innerHeight * 0.75;
      document.body.classList.toggle('keyboard-open', isKeyboardOpen);
    });
  }


  /* ─────────────────────────────────────────────
     3. FOOTER AKORDEON — Mobilde tıklanır kolonlar
     ───────────────────────────────────────────── */
  function initFooterAccordion(){
    if (window.innerWidth > 720) return;
    document.querySelectorAll('.foot__col').forEach(col => {
      const h5 = col.querySelector('h5');
      if (!h5 || h5.dataset.accordionBound === '1') return;
      h5.dataset.accordionBound = '1';
      h5.addEventListener('click', () => {
        col.classList.toggle('is-open');
      });
    });
  }


  /* ─────────────────────────────────────────────
     4. MOBILE MENU AKORDEON
     V100: Devre dışı bırakıldı — farren-redesign-widgets.js'de aynı handler
     mm elementine bağlı olarak zaten kayıtlı. Çift handler'da A açıyor B
     hemen kapatıyordu (her ikisi de "toggle others off + maybe-open" yapıyor;
     ikinci çağrı wasOpen=true görüp tekrar kapatıyordu). Tek handler bıraktık.
     ───────────────────────────────────────────── */
  function initMobileMenuAccordion(){
    // no-op — widgets.js is source of truth (see V100 header note above)
  }


  /* ─────────────────────────────────────────────
     5. DEBUG — Overflow gösterici (?debug=overflow)
     ───────────────────────────────────────────── */
  function initOverflowDebug(){
    if (!location.search.includes('debug=overflow')) return;
    document.querySelectorAll('*').forEach(el => {
      if (el.scrollWidth > document.documentElement.clientWidth + 1) {
        el.style.outline = '2px solid red';
        console.warn('Overflow element:', el, el.scrollWidth + 'px');
      }
    });
  }


  /* ─────────────────────────────────────────────
     INIT
     ───────────────────────────────────────────── */
  function init(){
    initFooterAccordion();
    initMobileMenuAccordion();
    initOverflowDebug();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  window.addEventListener('resize', () => {
    if (window.innerWidth <= 720) initFooterAccordion();
  });

})();
